module.exports = __webpack_public_path__ + "static/media/BROWN LETTER.fd5450c0.svg";